export default {
    fnam: '客戶全名',
    bsn: '統一編號',
    adr: '聯絡地址',
    bilL_DAY: '結帳日',
    soO_DAY: '付款日',
    note: '備註',
    nam: '聯絡窗口姓名',
    gen: '性別',
    job: '職稱',
    tel: '電話',
    ext: '分機',
    eml: 'E-mail',
    accountLast5Number: '匯款帳號後5碼',
};
